import { Container, Box, makeStyles } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import React, { useEffect, Fragment, useState } from "react";
import { Helmet } from "react-helmet";
import { PageBanner } from "../../components";
import { backend } from "../../api";
import { useParams } from "react-router";
import CustomPDFViewer from "../../components/CustomPDFViewer/CustomPDFViewer";
import { toast } from "react-toastify";

const useStyles = makeStyles((theme) => ({
  headingsContainer: {
    textAlign: "center",
    margin: "100px 0",
    color: theme.palette.secondary.light,
  },
  infoContainer: {
    textAlign: "justify",
    margin: "70px 0",
    color: theme.palette.secondary.light,
  },
  sectionHeading: {
    fontSize: "64px",
    color: theme.palette.secondary.light,
    fontWeight: 700,
    letterSpacing: 0.1,
    margin: "0 20px",
    lineHeight: "60px",
    [theme.breakpoints.down("md")]: {
      fontSize: "54px",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "45px",
      lineHeight: "40px",
      marginTop: "30px",
    },
  },
}));

function ReadBook() {
  const classes = useStyles();
  const [currentBook, setCurrentBook] = useState();
  const params = useParams();

  useEffect(() => {
    fetchCurrentBook();
  }, []);

  const fetchCurrentBook = () => {
    backend
      .get(`/book?_id=${params.bookId}`)
      .then((res) => {
        setCurrentBook(res.data.data[0]);
      })
      .catch((err) => {
        toast.error(err.response ? err.response.data.message : err.message);
      });
  };

  return (
    <Fragment>
      <Helmet>
        <title> E-Book Reading Zone</title>
      </Helmet>
      <PageBanner title="E-Book Reading Zone" image="/assets/images/bg4.jpg" />
      <div className={classes.headingsContainer}>
        <h6 style={{ fontWeight: 400, fontSize: "14px", letterSpacing: 5 }}>
          ENJOY YOUR BOOK
        </h6>
        <h2 className={classes.sectionHeading}> DECADE 2 PUBLISHING</h2>
      </div>

      <Container>
        <Box my={5}>
          {currentBook ? (
            <Box>
              <div className={classes.infoContainer}>
                <h6
                  style={{
                    fontWeight: 500,
                    fontSize: "13px",
                    letterSpacing: 3,
                  }}
                >
                  Book Title : {currentBook.book_title}
                </h6>
                <h6
                  style={{
                    fontWeight: 500,
                    fontSize: "13px",
                    letterSpacing: 3,
                  }}
                >
                  Book Author : {currentBook.author.name}
                </h6>
              </div>
              <CustomPDFViewer url={currentBook.pdf_file} bookId={params?.bookId} />
            </Box>
          ) : (
            <Box>
              <Skeleton animation="wave" />
            </Box>
          )}
        </Box>
      </Container>
    </Fragment>
  );
}

export default ReadBook;
